module.exports = __webpack_public_path__ + "media/נ.2ec4e057.mp3";